module.exports = __webpack_public_path__ + "static/media/light_fixture_GALAD.7fd4f312.png";